export default [
  {
    name: 'consumption',
    label: 'average_oil_usage',
    type: 'number',
    default: {},
  },
]
